export default __webpack_public_path__ + "static/media/BikeBlack.a1c6c2ba.png";